import { Component, OnInit } from '@angular/core';
import { DatePipe } from "@angular/common";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PujaPrasadService } from "./../../../prasad-order/puja-prasad.service";
import { PrasadOrderView } from "./../../../prasad-order/prasad-order";
import { PujaPrasadMaster } from './../../../prasad-order/puja-prasad-master';
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';


@Component({
  selector: 'app-admin-puja-prasad-order',
  templateUrl: './admin-puja-prasad-order.component.html',
  styleUrls: ['./admin-puja-prasad-order.component.css'],
  providers: [AdminDevoteeService, AdminPrasadOrderService, PujaPrasadService, AdminMobileappService]
})
export class AdminPujaPrasadOrderComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private activeRoute: ActivatedRoute,
    private adminDevoteeService: AdminDevoteeService,
    private adminPrasadOrderService: AdminPrasadOrderService,
    private pujaPrasadService: PujaPrasadService,
    private adminMobileAppService: AdminMobileappService) { }

  errorMessage: string;
  successMessage: string;
  devoteeDetail: DevoteeDetail;
  poDetail: PrasadOrderView;
  prasadOrderForm: FormGroup;
  pujaPrasadList: PujaPrasadMaster[] = [];
  previousPOList: any[] = [];

  ngOnInit() {



    this.createPrasadOrderForm();
    this.activeRoute.params.subscribe(params => this.loadPageData(params.devoteeId, params.poNo))

    this.loadPujaPrasadList();
  }

  private loadPageData(devoteeId: number, poNo: number) {

    if (poNo == undefined) {
      this.loadDevoteeDetails(devoteeId);
      return;
    }
    else {
      this.loadPODetails(poNo);
    }

  }

  private loadPujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadService.getPujaDetails().subscribe(
      data => {
        this.pujaPrasadList = data;
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      }
    )
  }

  loadDevoteeDetails(devoteeId: number) {
    console.log(devoteeId);

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchDevotee({ devoteeId: devoteeId }).subscribe(
      data => {
        this.devoteeDetail = data.PageData[0];
        this.loadPreviousPrasadOrders(this.devoteeDetail);
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      }
    )
  }

  loadPODetails(poNo: number) {
    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search({ OrderId: poNo }).subscribe(
      data => {
        this.devoteeDetail = data.DevoteeDetail;
        this.poDetail = data.OnlinePujaPrasadOrder;
        this.loadPreviousPrasadOrders(this.devoteeDetail);
        this.loadPOFormData();

        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      }
    )
  }

  loadPOFormData() {
    this.prasadOrderForm.controls.Amount.setValue(this.poDetail.Amount);
    this.prasadOrderForm.controls.PujaPrasadId.setValue(this.poDetail.PujaPrasadId);
    this.prasadOrderForm.controls.Gotra.setValue(this.poDetail.Gotra);

    let date = this.datePipe.transform(this.poDetail.OnWhichDate, 'y-MM-dd')
    console.log(date);
    this.prasadOrderForm.controls.OnWhichDate.setValue(date);
    this.prasadOrderForm.controls.YourWish.setValue(this.poDetail.YourWish);
    this.prasadOrderForm.controls.PaymentMode.setValue(this.poDetail.PaymentMode);
  }


  placeOrder(): void {

    if (this.prasadOrderForm.invalid) {
      this.sharedService.validateAllFormFields(this.prasadOrderForm);
      console.log(this.prasadOrderForm.errors);
      return;
    }

    if (this.poDetail == null) {
      this.poDetail = this.prasadOrderForm.value;
      this.poDetail.PrasadOrderDate = new Date();
      this.poDetail.DevoteeName = this.devoteeDetail.FirstName;
      var selectedPuja = this.pujaPrasadList.find(x => x.Id == this.poDetail.PujaPrasadId);

      if (selectedPuja != null)
        this.poDetail.PujaType = selectedPuja.TypeOfPuja;

    } else {
      let prasadOrder = this.prasadOrderForm.value;
      this.poDetail.Amount = prasadOrder.Amount;
      this.poDetail.PujaPrasadId = prasadOrder.PujaPrasadId;
      this.poDetail.PujaType = prasadOrder.PujaType;
      this.poDetail.Gotra = prasadOrder.Gotra;
      this.poDetail.OnWhichDate = prasadOrder.OnWhichDate;
      this.poDetail.YourWish = prasadOrder.YourWish;
      this.poDetail.PaymentMode = prasadOrder.PaymentMode;
    }



    if (this.devoteeDetail.MobileNo != null && this.devoteeDetail.MobileNo && this.devoteeDetail.MobileNo != 0) {
      this.poDetail.MobileNo = this.devoteeDetail.MobileNo;
    } else {
      this.poDetail.DevoteeId = this.devoteeDetail.Id
    }



    if ((this.poDetail.PaymentMode == "Cash") || (this.poDetail.PaymentMode == "MO")) {
      this.poDetail.PrasadOrderStatus = "Payment Sucessful";
    } else {
      this.poDetail.PrasadOrderStatus = "Payment Under Verification";
    }

    console.log(this.poDetail);

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.saveAndUpdate(this.poDetail).subscribe(
      data => {
        this.prasadOrderForm.markAsPristine();
        this.prasadOrderForm.reset();
        this.successMessage = data;
        //this.router.navigate(['pujaprasadseva','PaytmSuccess']);   

        let whatsAppMsgRequest = {
          MsgType: "OrderConfirmation",
          MobileNo: this.poDetail.MobileNo,
          DevoteeName: this.poDetail.DevoteeName,
          OrderId: parseInt(data.split(':')[1]),
          TotalAmount: this.poDetail.Amount.toString(),
          PujaVidhiName: this.poDetail.PujaType,
          PujaVidhiDate: this.poDetail.OnWhichDate
        }

        this.sendWhatsAppMsgOrderConfirmed(whatsAppMsgRequest);
        this.poDetail = null;
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  getPujaPrasadType(pujaPrasadId: number) {

    if (pujaPrasadId == 0)
      return "";

    return this.pujaPrasadList.find(x => x.Id == pujaPrasadId).TypeOfPuja;
  }


  loadPreviousPrasadOrders(devoteeDetail: DevoteeDetail) {
    this.errorMessage = "";

    let searchGridEntity = {
      PageNumber: 0,
      MobileNo: devoteeDetail.MobileNo,
      FirstName: devoteeDetail.FirstName,
      MiddleName: devoteeDetail.MiddleName,
      LastName: devoteeDetail.LastName,
    };

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.previousPOList = data.Data;
        let poWithGotra = this.previousPOList.find(x => x.OnlinePujaPrasadOrder && x.OnlinePujaPrasadOrder.Gotra);
        if (poWithGotra) {
          this.prasadOrderForm.controls.Gotra.setValue(poWithGotra.OnlinePujaPrasadOrder.Gotra);
        }

        this.loadPreviousMobilePrasadOrders(searchGridEntity, data.Data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  loadPreviousMobilePrasadOrders(searchGridEntity: any, webPrasadOrders: any[]) {

    this.sharedService.showSpinner();
    this.adminMobileAppService.search(searchGridEntity).subscribe(
      data => {
        console.log(data);

        var mobilePrasadOrders = data.data.PageData.map(x => ({
          OnlinePujaPrasadOrder: {
            Id: x.OrderId,
            PrasadOrderDate: x.OrderDate,
            PujaPrasadId: x.PujaVidhiId,
            Amount: x.VidhiCost,
            OnWhichDate: x.VidhiDate,
            PrasadOrderStatus: x.PrasadOrderStatus,
            Source: "MobileApp"
          },
          DevoteeDetail: {
            Id: 0
          }
        }));

        //var allPrasadOrders = [...mobilePrasadOrders, ...webPrasadOrders,]

        this.previousPOList = [...mobilePrasadOrders, ...webPrasadOrders,]
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  sendWhatsAppMsgOrderConfirmed(whatsAppMsgRequest: any) {

    this.sharedService.showSpinner();
    this.adminMobileAppService.whatsAppMsgSend(whatsAppMsgRequest).subscribe(
      data => {
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  createPrasadOrderForm(): void {
    this.prasadOrderForm = this.formBuilder.group({
      Amount: [, Validators.required],
      PujaPrasadId: [0],
      Gotra: [],
      OnWhichDate: [, Validators.required],
      YourWish: [],
      PaymentMode: ["PayUMoney"]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-puja-prasad-order/admin-puja-prasad-order.component.ts